import React from 'react'
import PropTypes from 'prop-types'

export default function NestedTabPills({
  tabsData,
  currentTab,
  handleTabChange,
  childTab,
  onChildTabChange,
}) {
  const activeTab = tabsData[currentTab]
  const hasChildren = activeTab?.children?.length > 0
  const safeChildTab = hasChildren && childTab < activeTab.children.length ? childTab : 0
  const content = hasChildren
    ? activeTab.children[safeChildTab]?.component
    : activeTab?.component

  const handleOuterClick = (idx) => {
    handleTabChange(idx)
  }

  return (
    <div className="nested-tabs">
      {/* Outer pills — unchanged; active indicator shows on all tabs including those with children */}
      <div className="nested-tabs__pills">
        {tabsData.map((tab, i) => (
          <div
            key={tab.title}
            className={`nested-tabs__pill${currentTab === i ? ' active' : ''}`}
            onClick={() => handleOuterClick(i)}
          >
            {tab.title}
          </div>
        ))}
      </div>

      {/*
        Platform block: wraps sub-pills + content together.
        When --active, overflow:hidden + border-radius clips the content card's top corners
        flush against the sub-pills bar bottom, joining them visually.
        Portals (OverlayTrigger tooltips, PortalModal) escape this clipping safely.
      */}
      <div
        className={`nested-tabs__platform-block${hasChildren ? ' nested-tabs__platform-block--active' : ''}`}
      >
        <div className={`nested-tabs__sub-pills${hasChildren ? ' nested-tabs__sub-pills--open' : ''}`}>
          {activeTab?.children?.map((child, i) => (
            <div
              key={child.title}
              className={`nested-tabs__sub-pill${safeChildTab === i ? ' active' : ''}`}
              onClick={() => onChildTabChange(i)}
            >
              {child.title}
            </div>
          ))}
        </div>
        <div className="nested-tabs__content">{content}</div>
      </div>
    </div>
  )
}

NestedTabPills.propTypes = {
  tabsData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      component: PropTypes.element,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          key: PropTypes.string,
          component: PropTypes.element.isRequired,
        }),
      ),
    }),
  ).isRequired,
  currentTab: PropTypes.number.isRequired,
  handleTabChange: PropTypes.func.isRequired,
  childTab: PropTypes.number,
  onChildTabChange: PropTypes.func,
}

NestedTabPills.defaultProps = {
  childTab: 0,
  onChildTabChange: () => {},
}
